export class SoftwareCollectorPackageModel {
	id?: string;
	title?: string;
	active?: boolean;
	packageName?: string;
	assignedTo?: string;
	accessLevel?: string;
}

export class AssignTo {
	id?: string;
	name?: string;
}

export class AccessLevel {
	id?: string;
	name?: string;
}

export const AssignToList = [
	{
		id: 'None',
		name: 'None'
	},
	{
		id: 'Borrower',
		name: 'Borrower'
	},
	{
		id: 'Appraiser',
		name: 'DataCollector'
	}
];

export const AccessLevelList = [
	{
		id: 'None',
		name: 'None'
	},
	{
		id: 'Admin',
		name: 'Admin'
	},
	{
		id: 'LimitedScanner',
		name: 'LimitedScanner'
	},
	{
		id: 'Scanner',
		name: 'Scanner'
	},
	{
		id: 'Supervisor',
		name: 'Supervisor'
	},
	{
		id: 'User',
		name: 'User'
	}
];
